import React from "react";

// Default rows for the mortgage table
export const defaultMortgageRows = [
  {
    item: "Combined fixed- and variable-rate (rate resets of less than 5 years)",
    number: "",
    loanValue: "",
  },
  { item: "Prepayment Penalty", number: "", loanValue: "" },
  { item: "Total Residential Mortgages", number: "", loanValue: "" },
];

const ResidentialMortgageTable = ({ mortgageTable, setMortgageTable }) => {
  // Fallback to defaults; only write to state on change
  const safeTableData =
    Array.isArray(mortgageTable) && mortgageTable.length
      ? mortgageTable
      : defaultMortgageRows;

  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...safeTableData];
    updated[rowIndex][field] = value;
    setMortgageTable(updated);
  };

  return (
    <div
      style={{
        marginTop: "16px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
        width: "100%",
        maxWidth: "none",
        marginInline: "auto",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th
              style={{
                ...tableHeaderStyle,
                textAlign: "left",
                paddingLeft: "16px",
              }}
            ></th>
            <th style={tableHeaderStyle}>Number</th>
            <th style={tableHeaderStyle}>Loan value</th>
          </tr>
        </thead>

        <tbody>
          {safeTableData.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  ...tableCellStyle,
                  textAlign: "left",
                  fontWeight: "600",
                  paddingLeft: "16px",
                  backgroundColor: "#D3C9CE",
                  whiteSpace: "normal",
                }}
              >
                {row.item}
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder=""
                  value={row.number}
                  onChange={(e) =>
                    handleInputChange(index, "number", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  step="any"
                  placeholder=""
                  value={row.loanValue}
                  onChange={(e) =>
                    handleInputChange(index, "loanValue", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Reuse styles consistent with your reference
const tableHeaderStyle = {
  padding: "20px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.25,
};

const tableCellStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.25,
};

const inputStyle = {
  width: "95%",
  padding: "14px",
  height: "40px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default ResidentialMortgageTable;
